var render = function render(){var _vm=this,_c=_vm._self._c;return _c('time-line',{attrs:{"itens":_vm.itensTimeLine}})
}
var staticRenderFns = []

export { render, staticRenderFns }